import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "backgroundStyle" }
const _hoisted_2 = { class: "loginStyle" }
const _hoisted_3 = { style: {"height":"calc(100% - 260px)"} }
const _hoisted_4 = { class: "fieldStyle" }
const _hoisted_5 = { style: {"width":"100%","text-align":"left","margin-left":"10%"} }
const _hoisted_6 = { class: "fieldStyle" }
const _hoisted_7 = { style: {"width":"100%"} }
const _hoisted_8 = { class: "fieldStyle" }
const _hoisted_9 = { style: {"width":"100%"} }
const _hoisted_10 = { class: "fieldStyle" }
const _hoisted_11 = { style: {"width":"100%"} }
const _hoisted_12 = { class: "fieldStyle" }
const _hoisted_13 = { style: {"width":"100%"} }
const _hoisted_14 = { class: "fieldStyle" }
const _hoisted_15 = { style: {"width":"100%"} }
const _hoisted_16 = { style: {"height":"85px","text-align":"left","margin-left":"10px"} }
const _hoisted_17 = { class: "loginBottomStyle" }
const _hoisted_18 = { class: "featuresFunction" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_star_filled = _resolveComponent("star-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[13] || (_cache[13] = _createElementVNode("div", { style: {"color":"rgb(76 104 139)"} }, [
        _createElementVNode("div", { class: "systemTitle" }, "OverallAuth2.0 统一权限分发中心"),
        _createElementVNode("div", { class: "systemSubTitle" }, "简单、易懂、功能强大，欢迎访问使用。")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_tag, null, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("密码登录")
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_el_select, {
              style: {"width":"80%"},
              size: "large",
              onChange: _ctx.corporationClick,
              modelValue: _ctx.loginForm.CorporationKey,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loginForm.CorporationKey) = $event)),
              placeholder: "请选择公司"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.corporationList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value,
                    disabled: item.disabled
                  }, null, 8, ["label", "value", "disabled"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["onChange", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_el_select, {
              style: {"width":"80%"},
              size: "large",
              onChange: _ctx.userClick,
              modelValue: _ctx.loginForm.UserName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.loginForm.UserName) = $event)),
              placeholder: "请选择用户"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item,
                    disabled: item.disabled
                  }, null, 8, ["label", "value", "disabled"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["onChange", "modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.loginForm.Password,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.loginForm.Password) = $event)),
              style: {"width":"80%","height":"40px"},
              placeholder: "请输入密码",
              type: "password",
              "show-password": "",
              "prefix-icon": _ctx.Hide
            }, null, 8, ["modelValue", "prefix-icon"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.code,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.code) = $event)),
              style: {"width":"80%","height":"40px"},
              placeholder: "请输入验证码",
              "prefix-icon": _ctx.Position
            }, null, 8, ["modelValue", "prefix-icon"])
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_el_button, {
              onClick: _ctx.loginClick,
              type: "primary",
              style: {"width":"80%","height":"50px"}
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("登录")
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createVNode(_component_el_checkbox, {
          modelValue: _ctx.isStarted,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.isStarted) = $event)),
          label: "码云是否Star",
          size: "large"
        }, null, 8, ["modelValue"]),
        _cache[7] || (_cache[7] = _createElementVNode("div", { style: {"color":"red","font-size":"12px"} }, " *为了帮助更多的人知道及了解本项目,请帮忙Star。拜谢各位🙏🙏🙏 ", -1))
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(_component_el_divider, { "content-position": "left" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_icon, { color: "red" }, {
              default: _withCtx(() => [
                _createVNode(_component_star_filled)
              ]),
              _: 1
            }),
            _cache[8] || (_cache[8] = _createTextVNode("特色功能"))
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_18, [
          _createVNode(_component_el_tag, null, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("可视化权限设计")
            ])),
            _: 1
          }),
          _createVNode(_component_el_tag, { type: "success" }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("数据行权限")
            ])),
            _: 1
          }),
          _createVNode(_component_el_tag, { type: "warning" }, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode("数据列权限")
            ])),
            _: 1
          }),
          _createVNode(_component_el_tag, { type: "danger" }, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode("完整流程审批")
            ])),
            _: 1
          })
        ])
      ])
    ])
  ]))
}